import TabIcon from '../TabIcon';
import type { HomeTabProps } from '../types';
import { getTabClasses } from '../utils';

const HomeTab = ({ tab, activeTabId, onClick, className }: HomeTabProps) => {
  const isActiveTab = tab.id === activeTabId;
  const opacityClasses = `group-hover:opacity-100 ${isActiveTab ? 'opacity-100' : 'opacity-50'}`;

  return (
    <button
      type="button"
      onClick={() => onClick(1)}
      className={`${getTabClasses(
        isActiveTab
      )} justify-center w-[var(--ds-tab-sizing-home-tab-width)] min-w-[var(--ds-tab-sizing-home-tab-width)] group ${
        className || ''
      }`}
      data-testid="global-tab"
    >
      <span className={opacityClasses}>
        <TabIcon tab={tab} />
      </span>
    </button>
  );
};

export default HomeTab;
